import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'instant' as ScrollBehavior
    });
  }, [pathname]);
  return <div className="relative w-full bg-[#050608] text-white selection:bg-[#1a8fd4]/30" data-id="element-1035">
      {/* Skip-to-content link — visible only when focused.
              Keyboard / screen-reader users land on this first and can jump
              straight to the main landmark. Satisfies WCAG 2.4.1 (Bypass Blocks). */}
      <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:px-4 focus:py-2 focus:bg-white focus:text-black focus:rounded-md focus:font-medium focus:text-sm focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-[#1a8fd4]" data-id="element-1036">
        Skip to main content
      </a>

      {/* SVG filter defs (logo background removal) */}
      <svg width="0" height="0" className="absolute" aria-hidden="true" data-id="element-1037">
        <defs data-id="element-1038">
          <filter id="periscan-remove-white" colorInterpolationFilters="sRGB" data-id="element-1039">
            <feColorMatrix type="matrix" values="-1 0 0 0 1
                       0 -1 0 0 1
                       0 0 -1 0 1
                       0 0 0 1 0" data-id="element-1040" />
            <feColorMatrix type="hueRotate" values="180" data-id="element-1041" />
            <feColorMatrix type="matrix" values="1 0 0 0 0
                      0 1 0 0 0
                      0 0 1 0 0
                      1 1 1 0 0" data-id="element-1042" />
          </filter>
        </defs>
      </svg>

      <Header data-id="element-1043" />
      <main id="main-content" tabIndex={-1} className="pt-9 min-h-screen scroll-mt-24" data-id="element-1044">
        <Outlet data-id="element-1045" />
      </main>
      <Footer data-id="element-1046" />
    </div>;
}